// this is an autogenerated file from DesignSystem/Report/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_Report($type: reports_report_types_enum!) {
  reports_executions(
    where: {
      report_type: { _eq: $type }
      app_key_id: { _is_null: true }
      status: { _neq: expired }
    }
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    status
    url
    created_at
    filters
    message
  }
}

`